// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"7645f217","787":"69155f39"}[chunkId] + ".chunk.js";
};